import { TimePlot } from '../src/timeplot'
import { App, DataSource } from '../src/data_source'

let plots = [];
let signalParams = [];
const NUM_PLOTS: const = 9;
const LINES_PER_PLOT = 8;
const STEPS_PER_STEP = 2;
const dt = 0.001;


for (let row = 0; row < NUM_PLOTS; row++) {
  let timeplot: TimePlot = new TimePlot("data", document.getElementById("timeplot_"+row), LINES_PER_PLOT, 1000, [0, 1]);
  plots.push(timeplot);

  let lineData = [];
  for (let i = 0; i < LINES_PER_PLOT; i++) {
    lineData.push([i, Math.random(), Math.random(), Math.random(), Math.random()])
  }
  signalParams.push(lineData);
}



const app = new App();
app.run(null, plots)
//
let t = 0;

function sine(t, f, phase, amp, offset) {
  return amp*Math.sin(t * 2 * Math.PI * f + phase)+offset;
}
function tri(t, p) {
  return Math.abs(2 * (t / p - Math.floor(t/p + .5)));
}
function step(){
    t += dt * STEPS_PER_STEP;
    for (let row = 0; row < NUM_PLOTS; row++){
      let plotData = [];

      let signalParamsPlot = signalParams[row];
      for (let step = 0; step < STEPS_PER_STEP; step++){
        let plotDataStep = [];
        for (let i = 0; i < LINES_PER_PLOT; i++) {
          let p = signalParamsPlot[i];
          let x;
          if ((row % 2) == 0){
            let f = sine(t + dt * step, .1, p[2]*10, .5, .5);
            x = sine(t + dt * step, .1 + p[1]*.5 + 1/(f+.5) + row / 2, 0, .04, p[0]/LINES_PER_PLOT+.5/LINES_PER_PLOT);
          } else if (row % 2 == 1){
            x = tri(t + dt * step, (p[2]*2 + 1)) * p[3]/LINES_PER_PLOT + p[0] / LINES_PER_PLOT +.5/LINES_PER_PLOT;
          }
          plotDataStep.push(x);
        }
        plotData.push(plotDataStep)
      }
      plots[row].update(plotData);
    }
  }
}
setInterval(step, 2);
